/* eslint-disable no-param-reassign, eqeqeq */
import Sentence from 'es6/models/sentence';
import Transliterable from 'es6/models/transliterable';

export default class ItemPackage {
  constructor(attrs = {}) {
    _.defaults(this, attrs, {
      annotation: null,

      distractors: {
        cue: [],
        response: [],
      },

      goalId: null,

      item: {
        id: null,

        cue: {
          image: null,
          language: null,
          partOfSpeech: null,
          text: null,
          transcription: null,
          transliterations: {},
        },

        response: {
          language: null,
          text: null,
          transcription: null,
          transliterations: {},
        },

        type: null,
      },

      position: null,

      sentences: [],

      sound: null,
    });

    // Cast sentences as sentence object.
    this.sentences = this.sentences.map((sentence) => {
      sentence.goalId = this.goalId;
      sentence.itemId = this.getId();
      return !(sentence instanceof Sentence) ? new Sentence(sentence) : sentence;
    });

    // Convert all transliterable objects.
    this.item.cue = new Transliterable(this.item.cue);
    this.item.response = new Transliterable(this.item.response);

    // Override the language for the distractors, as they are not a reliable
    // source of information.
    const distractors = this.distractors;

    distractors.cue = distractors.cue.map(cue => {
      cue.language = this.item.cue.language;
      return new Transliterable(cue);
    });

    distractors.response = distractors.response.map(response => {
      response.language = this.item.response.language;
      return new Transliterable(response);
    });
  }

  /**
   * @returns {Boolean}
   */
  isKanaCourseItem() {
    const goalId = this.goalId;
    return goalId == 24666 || goalId == 24667;
  }

  getId() {
    return this.item.id;
  }

  /**
   * @returns {String}
   */
  getAnnotation() {
    return this.annotation;
  }

  getImage() {
    return this.item.cue.image;
  }

  getPartOfSpeech() {
    if (this.item.cue.partOfSpeech === 'None') {
      return null;
    }

    return this.item.cue.partOfSpeech;
  }

  /**
   * Gets the language.
   *
   * @returns {String}
   */
  getLanguage() {
    return this.item.cue.language;
  }

  /**
   * @returns {Sentence[]}
   */
  getSentences() {
    return this.sentences;
  }

  /**
   * Gets the primary text for the cue.
   *
   * @returns {String}
   */
  getText() {
    return this.item.cue.getText();
  }

  /**
   * Gets the best transliteration for the cue.
   *
   * @returns {String}
   */
  getTransliteration() {
    return this.item.cue.getTransliteration();
  }

  /**
   * Returns the translation for the item package.
   *
   * @returns {String}
   */
  getTranslation() {
    return this.item.response.text;
  }
}
